module.exports = __webpack_public_path__ + "img/Yellow.1444f5f7.jpg";